
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';



// Image data
const img = [
  { img: '/slider1.webp' },
  { img: '/slider2.webp' },
  { img: '/slider3.webp' },
  { img: '/slider4.webp' },
  { img: '/slider5.webp' },
];

function Slider() {


  return (


    <div className="my-2">
      <Swiper
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        lazy={true}
        loop={true}
        style={{ overflow: 'hidden' }}
      >
        {img.map((slide, index) => (
          <SwiperSlide key={index}>
            <img
              src={slide.img}
              loading={index === 0 ? 'eager' : 'lazy'}
              className={`w-100 ${index !== 0 ? 'swiper-lazy' : ''}`}
              alt={'slide' + index}
              style={{ objectFit: 'cover' }}
            />
            {index !== 0 && <div className="swiper-lazy-preloader"></div>}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default Slider;
